import React, { useState } from 'react';
import { Button, Checkbox, Dropdown, MenuProps, Space, Typography, theme } from "antd";
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { DownOutlined } from '@ant-design/icons';
import { ItemType } from 'antd/es/menu/hooks/useItems';

import { FilterProps } from '../../tables/table.component';
import { Filter, i18n } from '../../../common';

const { Title } = Typography;
const { useToken } = theme;

interface FilterValue {
  id: number;
  label: string;
  checked: boolean;
  filter: Filter;
}

const CampaignFilter = ({ dataKey, handleFilterChange }: FilterProps): JSX.Element => {

  const CampaignFilterValues: Array<FilterValue> = [
    { id: 1, label: i18n.translate("common.constants.campaign.individual"), filter: {name: dataKey, operator: 'EQ', value: 'null'}, checked: false },
    { id: 2, label: i18n.translate("common.constants.campaign.partOfCampaign"), filter: {name: dataKey, operator: 'NEQ', value: 'null'}, checked: false }
  ]

  const [filterValues, setFilterValues] = useState<Array<FilterValue>>(CampaignFilterValues);

  const [open, setOpen] = useState(false);

  const onValueChange = (value: boolean, filterValue: FilterValue) => {
    setFilterValues(filterValues.map((fv: FilterValue) => fv.id === filterValue.id
      ? { ...fv, checked: value }
      : { ...fv }))
  }

  const onFilterConfirm = () => {
    if (filterValues.filter((fv: FilterValue) => fv.checked).length !== 1) {handleFilterChange();}
    else {handleFilterChange(filterValues.find((fv: FilterValue) => fv.checked)!.filter);}
    setOpen(false);
  }

  const handleOpenChange = (flag: boolean) => {
    setOpen(flag);
  };

  // konfiguracija menu-a unutar dropdowna
  const items: MenuProps['items'] = CampaignFilterValues.map((filterValue: FilterValue, index: number) => {
    const item: ItemType = {
      label: (
        <Checkbox
          onChange={(e: CheckboxChangeEvent) => {
            onValueChange(e.target.checked, filterValue);
          }}
          checked={filterValues.find((fv: FilterValue) => fv.id === filterValue.id)?.checked}
        >
          {filterValue.label}
        </Checkbox>
      ),
      key: index
    }
    return item;
  })

  // Dropdown i menu style - nažalost ant design nije ponudio kvalitetnije rješenje, a nisam htio iz nule raditi dropdown i menu
  const { token } = useToken();

  const contentStyle = {
    backgroundColor: token.colorBgElevated,
    borderRadius: token.borderRadiusLG,
    boxShadow: token.boxShadowSecondary,
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 8,
    paddingRight: 8
  };

  const menuStyle = {
    boxShadow: 'none',
    padding: 0,
    margin: 0
  };

  return (
    // <Select key={dataKey} onChange={onFilterChange} options={[{ value: 1, label: 'Admin' },{ value: 2, label: 'Marketing' }]}/>
    <Dropdown
      menu={{ items }}
      open={open}
      onOpenChange={handleOpenChange}
      trigger={['click']} dropdownRender={(menu) => (
        <div style={contentStyle}>
          <Title level={3} style={{ paddingLeft: 12, paddingRight: 12, paddingBottom: 8 }}>{i18n.t('components.filters.campaign')}</Title>
          {React.cloneElement(menu as React.ReactElement, { style: menuStyle })}
          <Space style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: 16 }}>
            <Button type='link' onClick={onFilterConfirm}>
              Filtriraj
            </Button>
          </Space>
        </div>
      )}
    >
      <a onClick={(e) => e.preventDefault()}>
        <Space>
          {i18n.t('components.filters.campaign')}{filterValues.find((f: FilterValue) => f.checked) && `(${filterValues.filter((f: FilterValue) => f.checked).length})`}
          <DownOutlined />
        </Space>
      </a>
    </Dropdown>
  )
}

export default CampaignFilter;
